import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Top3 from "./pages/Top3";
import RecomendMe from "./pages/RecomendMe";
import ProductDetail from "./pages/ProductDetail";
import { GlobalStateProvider } from "./context/GlobalState";

function App() {
  return (
    <GlobalStateProvider>
      <Router>
        <Routes>
          <Route path="/" element={<RecomendMe />} />
          <Route path="/top3" element={<Top3 />} />
          <Route
            path="/v1/products/:productId/:purpose"
            element={<ProductDetail />}
          />
        </Routes>
      </Router>
    </GlobalStateProvider>
  );
}

export default App;
